import toDate from 'date-fns/toDate'

export const general = {
  getClaimStatusDetail: (state) => {
    return (statusCode) => {
      if (state.claimDetail.commonInfo.statuses && state.claimDetail.commonInfo.statuses.length > 0) {
        const filterStatuses = state.claimDetail.commonInfo.statuses.filter(status => status.statusCode === statusCode)
        if (filterStatuses && filterStatuses.length > 0) {
          // Get the latest 1 if there are multiple status with the same code (Life cycle can go to and fro)
          filterStatuses.sort((a, b) => {
            return toDate(b.statusDate) - toDate(a.statusDate)
          })
          return filterStatuses[0]
        }
      }
      return null
    }
  }
}
